import React from 'react';
import Badge from '../Badge';
import { PRIORITY_LABELS, PRIORITY_VARIANTS } from './constants';

interface PriorityBadgeProps {
  priority: string;
}

// Badge di priorita del ticket.
const PriorityBadge: React.FC<PriorityBadgeProps> = ({ priority }) => (
  <Badge variant={PRIORITY_VARIANTS[priority] || 'secondary'} size="small">
    {PRIORITY_LABELS[priority] || priority}
  </Badge>
);

export default PriorityBadge;
